// C1-INT Level Aggregator - İleri Mülakat Eğitimi
// Tüm C1-INT ünite içeriklerini birleştirir

import { C1INT_UNIT_1 } from './kariyerContentsC1INTUnit1';
import { C1INT_UNIT_2 } from './kariyerContentsC1INTUnit2';
import { C1INT_UNIT_3 } from './kariyerContentsC1INTUnit3';

export const C1INT_LEVEL = {
  ...C1INT_UNIT_1,  // İleri Behavioral Sorular
  ...C1INT_UNIT_2,  // Havayolu Spesifik Sorular
  ...C1INT_UNIT_3,  // Final Interview ve Panel
};

export default C1INT_LEVEL;
